import React, { useState } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CustomCalendarPicker from '../CustomWeekPicker/CustomCalendarPicker';
import { calendarTypes } from '../../../utils/constants';
import BaseSwipeableDrawer from '../BaseSwipeableDrawer/BaseSwipeableDrawer';
import classes from './CustomDayPicker.module.scss';

export default function CustomDayPicker({ date, changeHandler, sx, dayFormat, sxAdornment = {} }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  const [newDate, setDate] = useState(date);

  const handleCalendar = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handlePicker = (dt) => {
    setAnchorEl(null);
    setDate(dt);
    changeHandler(dt);
  };

  return (
    <>
      <TextField
        id="outlined-start-adornment"
        onClick={handleCalendar}
        value={dayjs(newDate).format(dayFormat)}
        sx={sx}
        InputProps={{
          endAdornment: (
            <InputAdornment sx={sxAdornment} position="end">
              <CalendarMonthIcon />
            </InputAdornment>
          )
        }}
      />
      {open && (
        <BaseSwipeableDrawer isDivider closeHandler={() => setAnchorEl(false)}>
          <h5 className={classes.header}>{t('common.general.day')}</h5>
          <CustomCalendarPicker
            userDate={date === t('dashboard.timesheets.filters.day') ? dayjs() : date}
            setUserDate={handlePicker}
            calendarType={calendarTypes.DAY}
            sx={{
              width: '100%',
              padding: '15px'
            }}
          />
        </BaseSwipeableDrawer>
      )}
    </>
  );
}
